import { render, staticRenderFns } from "./ResSuccess.vue?vue&type=template&id=4df5aa58&scoped=true&"
import script from "./ResSuccess.vue?vue&type=script&lang=js&"
export * from "./ResSuccess.vue?vue&type=script&lang=js&"
import style0 from "./ResSuccess.vue?vue&type=style&index=0&id=4df5aa58&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4df5aa58",
  null
  
)

component.options.__file = "ResSuccess.vue"
export default component.exports